import React from "react";

// The closing section is intentionally spartan: a backstage photo, a single
// headline, and a direct email. No form — decisions get made over email.
export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative w-full overflow-hidden"
      style={{ background: "#080808" }}
    >
      {/* Backstage photo as the section background — the visual anchor of the
          closing screen. Grayscale + darkened so the copy reads cleanly. */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{ zIndex: 0 }}
      >
        <img
          src="https://customer-assets.emergentagent.com/job_vertical-studio-1/artifacts/j5d2pxak_backstage_pic.png"
          alt=""
          draggable={false}
          data-testid="backstage-photo"
          className="w-full h-full object-cover"
          style={{
            filter: "grayscale(1) contrast(1.05) brightness(0.72)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{ background: "rgba(8, 8, 8, 0.72)" }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(8,8,8,0.55) 0%, rgba(8,8,8,0.35) 40%, rgba(8,8,8,0.75) 100%)",
          }}
        />
      </div>

      {/* Content — sits on the darkened backstage image. */}
      <div className="relative py-20 md:py-32" style={{ zIndex: 1 }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div
            className="text-[11px] tracking-[0.35em] uppercase mb-10"
            style={{ color: "#A1A1AA" }}
          >
            <span style={{ color: "#FF6A3D" }}>—</span>&nbsp;&nbsp;Contact
          </div>

          <h2
            className="leading-[0.95] max-w-5xl"
            style={{
              fontSize: "clamp(2.75rem, 7.5vw, 6.5rem)",
              letterSpacing: "-0.04em",
              fontWeight: 500,
            }}
            data-testid="contact-headline"
          >
            Let&rsquo;s build your<br />next title.
          </h2>

          <div className="mt-20 md:mt-28 grid grid-cols-12 gap-10">
            <div className="col-span-12 md:col-span-8">
              <p
                className="mb-8 leading-[1.55]"
                style={{
                  color: "#F5F5F3",
                  opacity: 0.85,
                  fontSize: "clamp(1.05rem, 1.35vw, 1.25rem)",
                  fontWeight: 400,
                  letterSpacing: "-0.005em",
                  maxWidth: "560px",
                }}
                data-testid="contact-copy"
              >
                For production inquiries, send us a request at:
              </p>
              <a
                href="mailto:production@livingroom.pictures"
                data-testid="contact-email"
                className="lr-contact-mail inline-block"
                style={{
                  color: "#F5F5F3",
                  fontSize: "clamp(1.75rem, 4vw, 3rem)",
                  letterSpacing: "-0.02em",
                  fontWeight: 500,
                  lineHeight: 1.05,
                  borderBottom: "1px solid rgba(245,245,243,0.25)",
                  paddingBottom: 6,
                }}
              >
                production@livingroom.pictures
              </a>
              <p
                className="mt-10 leading-[1.55]"
                style={{
                  color: "#A1A1AA",
                  fontSize: "clamp(0.95rem, 1.15vw, 1.05rem)",
                  fontWeight: 400,
                  letterSpacing: "0.005em",
                  maxWidth: "560px",
                }}
                data-testid="contact-followup"
              >
                We&rsquo;ll get back to you shortly.
              </p>
            </div>

            <div className="col-span-12 md:col-span-4 md:col-start-9">
              <div
                className="text-[10px] tracking-[0.3em] uppercase mb-4"
                style={{ color: "#A1A1AA" }}
              >
                Studio
              </div>
              <p
                className="text-base font-light"
                style={{ color: "#F5F5F3", opacity: 0.85, lineHeight: 1.55 }}
              >
                Warsaw, Poland
              </p>

              <div
                className="mt-10 text-[10px] tracking-[0.3em] uppercase mb-4"
                style={{ color: "#A1A1AA" }}
              >
                For
              </div>
              <p
                className="text-base font-light"
                style={{ color: "#F5F5F3", opacity: 0.85, lineHeight: 1.55 }}
              >
                Vertical drama platforms
                <br />
                Co-productions
                <br />
                Original IP
              </p>
            </div>
          </div>

          <footer
            className="mt-40 md:mt-56 pt-10 flex flex-wrap items-center justify-between gap-4"
            style={{ borderTop: "1px solid #141414" }}
          >
            <span
              className="text-lg"
              style={{ letterSpacing: "-0.01em", fontWeight: 600 }}
            >
              Livingroom<span style={{ color: "#FF6A3D" }}>.</span>
            </span>
            <span
              className="text-[10px] tracking-[0.3em] uppercase"
              style={{ color: "#A1A1AA" }}
              data-testid="footer-location"
            >
              MMXXV · Warsaw · Poland
            </span>
          </footer>
        </div>
      </div>
    </section>
  );
};

export default Contact;
